import React from 'react';
import { injectIntl } from 'react-intl';
import { inject, observer } from 'mobx-react';
import ReactJoyride, { STATUS } from 'react-joyride';
import PropTypes from 'prop-types';
import css from '@emotion/css';
import Tooltip from '../../components/OnboardingTutorialTooltip';
import { tutorial_steps } from '../../components/OnboardingTutorialSteps/steps';
import IconSvg from '../../components/common/IconSvg/IconSvg';
import Button from '../../components/common/Button/Button';

const BeaconComponent = () => (
  <span />
);

@injectIntl
@inject('onboardingStore')
@observer
class Tutorial extends React.Component {

  handleJoyrideCallback = data => {
    if (!this.props.onboardingStore.storeInitialized) {
      return;
    }

    const {
      status, // index, type, action
    } = data;
    // let tutorialStepIndex = index;

    if (STATUS.FINISHED === status) {
      this.props.onboardingStore.disableTutorial();
    // } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // tutorialStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
      // this.props.onboardingStore.setTutorialStep(tutorialStepIndex);
    }
  };

  render() {

    const {
      tutorialStepIndex, runTutorial, wizardDone, maximizeTutorial, tutorialEnabled
    } = this.props.onboardingStore;

    if (!wizardDone || !tutorialEnabled) {
      return null;
    }
    return (
      <div id="onboarding-tutorial">
        <Button
          clickHandler={maximizeTutorial}
          css={css`
            position: fixed;
            right: 1rem;
            bottom: 5.5rem;
            border: 0;
            padding: 0;
          `}
          type="ghost"
        >
          <IconSvg
            size={40}
            type="onboarding-min"
          />
        </Button>
        <ReactJoyride
          beaconComponent={BeaconComponent}
          tooltipComponent={Tooltip}
          steps={tutorial_steps}
          stepIndex={tutorialStepIndex}
          run={runTutorial}
          continuous
          disableOverlay
          callback={this.handleJoyrideCallback}
        />
      </div>
    );
  }
}

Tutorial.propTypes = {
  onboardingStore: PropTypes.object
};

export default Tutorial;
